/** Perform deep equal checking (using strigify method) on two objects */
export function DeepEqual(a, b) {
  // TODO: Could potentially be faster by using approach of Path.copy.
  if (typeof a === 'object' && typeof b === 'object') return JSON.stringify(a) == JSON.stringify(b);
  else return a === b;
}
